"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _imageViewer = _interopRequireDefault(require("element-ui/packages/image/src/image-viewer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ElImageViewer: _imageViewer.default
  },
  data: function data() {
    return {
      visible: false,
      imageList: [],
      index: 0,
      tips: ''
    };
  },
  watch: {},
  methods: {
    open: function open() {
      this.visible = true;
    },
    onClose: function onClose() {
      this.imageList = [];
      this.tips = "";
      this.index = 0;
      this.visible = false;
    }
  }
};